// extracted by mini-css-extract-plugin
export default {"recos":"U6-z","productCardOverride":"V6-z","rowHasBadge":"W6-z"};